import React from "react";

import { ButtonContainer } from "./styles";

const Button = ({ ...props }) => {
  return <ButtonContainer {...props} />;
};

export default Button;
